import React, { useState, useEffect, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast"; // ✅ tambahkan ini
import AppSidebar from "./AppSidebar";
import Topbar from "./Topbar";
import { AuthContext } from "../../contexts/AuthContext";
import api from "../../api";

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pageTitle, setPageTitle] = useState("Dashboard");
  const [menus, setMenus] = useState([]);
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const toggleSidebar = () => setCollapsed(!collapsed);
  const closeSidebarMobile = () => isMobile && setCollapsed(true);

  // Deteksi ukuran layar
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [isMobile]);

  // Ambil menu berdasarkan role user
  useEffect(() => {
    if (!user?.idRole) return;
    api
      .get(`/Menu/by-role/${user.idRole}`)
      .then((res) => {
        const formattedMenus = res.data.map((menu) => ({
          idMenu: menu.idMenu,
          title: menu.title,
          path: menu.path,
          icon: menu.icon,
          children: (menu.subMenu || []).map((sub) => ({
            idMenu: sub.idMenu,
            title: sub.title,
            path: sub.path,
            icon: sub.icon,
            children: sub.subMenu || [],
          })),
        }));
        setMenus(formattedMenus);
      })
      .catch((err) => console.error("Gagal memuat menu:", err));
  }, [user]);

  // Update judul halaman berdasarkan path
  useEffect(() => {
    const findTitle = (menuList, path) => {
      for (const menu of menuList) {
        if (menu.path === path) return menu.title;
        if (menu.children?.length) {
          const childTitle = findTitle(menu.children, path);
          if (childTitle) return childTitle;
        }
      }
      return null;
    };

    const newTitle = findTitle(menus, location.pathname);
    setPageTitle(newTitle || "Dashboard");
  }, [location.pathname, menus]);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-300">
      {/* Sidebar */}
      <AppSidebar
        collapsed={collapsed}
        isMobile={isMobile}
        onCloseMobile={closeSidebarMobile}
        menus={menus}
      />

      {/* Area utama */}
      <div className="flex flex-col flex-1 transition-all duration-300">
        <Topbar
          toggleSidebar={toggleSidebar}
          user={user}
          pageTitle={pageTitle}
        />

        {/* Konten utama */}
        <main className="flex-1 p-4 overflow-auto bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
          <Outlet />
        </main>
      </div>

      {/* ✅ Tambahkan di sini agar selalu aktif */}
      {/* <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            zIndex: 9999,
          },
        }}
      /> */}
    </div>
  );
};

export default AppLayout;
